module.exports = {
	"htm": "text/html",
	"html": "text/html",
	"txt": "text/plain",
	"log": "text/plain",
	"md": "text/x-markdown",
	"markdown": "text/x-markdown",
	"rst": "text/x-rst",
	"webm": "video/webm",
	"mov": "video/quicktime",
	"avi": "video/x-msvideo",
	"mp4": "video/mp4",
	"mkv": "video/x-matroska",
	"mp3": "audio/mpeg",
	"wav": "audio/wave",
	"zip": "application/zip",
	"rar": "application/x-rar-compressed",
	"jar": "application/java-archive",
	"tar": "application/x-tar",
	"bz2": "application/x-bzip2",
	"gz": "application/x-gzip",
	"png": "image/png",
	"gif": "image/gif",
	"jpg": "image/jpeg",
	"jpeg": "image/jpeg",
	"svg": "image/svg+xml",
	"js": "application/javascript",
	"jsx": "text/jsx",
	"py": "application/x-python",
	"c": "text/x-c",
	"cpp": "text/x-c",
	"h": "text/x-c",
	"cxx": "text/x-c",
	"java": "text/x-java-source",
	"json": "application/json",
	"csv": "text/csv",
	"css": "text/css",
	"wdf": "text/wdf",
	"/": "text/wdf",
	"xml": "application/xml",
	"xls": "application/vnd.ms-excel",
	"doc": "application/msword",
	"pdf": "application/pdf",
	"docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	"*": "application/octet-stream"
};


/*****************
 ** WEBPACK FOOTER
 ** ./ext2mime.json
 ** module id = 34
 ** module chunks = 0
 **/